import React, {Component} from 'react';
import {Paper, Table, TableContainer, TableHead, TableRow, TableCell, TableBody} from "@material-ui/core";
import DateUtil from "../../../Utils/DateUtil";
import {ArrowDownward, ArrowUpward} from "@material-ui/icons";
import Recibo from "./Recibo";
import PaginationComponent from "../../../Components/PaginationComponent/PaginationComponent";
import SpacerComponent from "../../../Components/SpacerComponent/SpacerComponent";
import ExtractClientScreen from "../ExtractClientScreen/ExtractClientScreen";
import {ValidationReportContext} from "../../../Contexts/ValidationReportContext";

class TableValidationReport extends Component {
    static contextType = ValidationReportContext;

    constructor(props) {
        super(props);

        this.enterValue = [
            'Nota fiscal',
            'Recibo',
        ];
    }

    makeRowTable() {

        const rows = [];
        const context = this;

        Object.keys(context.props.extractList).forEach(function (key, index) {
            const value = context.props.extractList[key];
            rows.push(
                <TableRow key={value.uuid}>
                    <TableCell>{value.award.title}</TableCell>
                    <TableCell>{DateUtil.raw(value.created_at).toDateTime24()}</TableCell>
                    <TableCell>{value.company.fantasy_name}</TableCell>
                    <TableCell>{value.validated_by.name}</TableCell>
                    <TableCell>{value.original_amount !== value.received_amount ? 'Sim' : 'Não'}</TableCell>
                    <TableCell>
                        <Recibo value={value}/>
                    </TableCell>
                </TableRow>
            );
        });

        return rows;

    }

    tryGetLink(value) {
        try {

            return <a
                href={`${ExtractClientScreen.ROUTE}/${value.client_uuid}/${value.fidelity_program_uuid}`}>{value.client}</a>;

        } catch (e) {
            return value.client;
        }
    }

    getIcon(type) {
        if (this.enterValue.includes(type)) {
            return <ArrowDownward htmlColor={'#35a863'}/>;
        }

        return <ArrowUpward htmlColor={'#bd4343'}/>;
    }

    render() {
        return (
            <div>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Tipo</TableCell>
                                <TableCell>Cadastro em</TableCell>
                                <TableCell>Estabelecimento</TableCell>
                                <TableCell>Operador</TableCell>
                                <TableCell>Divergência</TableCell>
                                <TableCell>Comprovante</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.makeRowTable()}
                        </TableBody>
                    </Table>
                </TableContainer>
                <SpacerComponent height={20}/>
                <PaginationComponent total={parseInt(this.context.parent.state?.pagination?.total)}
                                     perPage={parseInt(this.context.parent.state?.pagination?.per_page)}
                                     currentPage={parseInt(this.context.parent.state?.pagination?.current_page)}
                                     lastPage={parseInt(this.context.parent.state?.pagination?.last_page)}
                                     itensVisible={2}
                                     onChangePage={(page) => {
                                         this.context.parent.doChangePage({page});
                                     }}/>
            </div>
        );
    }
}

export default TableValidationReport;